import { FileFolderPath } from '@nextforce/api'
import { makeStyles, Text } from '@rneui/themed'
import { useEffect, useRef } from 'react'
import { View } from 'react-native'
import { FlatList } from 'react-native-gesture-handler'
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated'
import { PressableOpacity } from 'shared/components/pressable_opacity'
import { getDarkShadeColor, getLightShadeColor } from 'shared/utils'

export function Breadcrumbs({
  breadcrumbs,
  onPressBreadcrumb,
}: {
  breadcrumbs: FileFolderPath[]
  onPressBreadcrumb: (index: number) => void
}) {
  const styles = useStyles()
  const flatListRef = useRef<FlatList>(null)

  useEffect(() => {
    if (breadcrumbs.length && flatListRef.current) {
      flatListRef.current.scrollToEnd({ animated: true })
    }
  }, [breadcrumbs])

  return (
    <View>
      <FlatList
        ref={flatListRef}
        horizontal
        data={breadcrumbs}
        renderItem={({ item, index }) => (
          <Animated.View entering={FadeIn} exiting={FadeOut}>
            <PressableOpacity
              key={item.id}
              onPress={() => onPressBreadcrumb(index)}
              style={styles.breadcrumbItem}
            >
              <View style={styles.breadcrumbItemContainer}>
                <Text>{item.name}</Text>
              </View>

              {index < breadcrumbs.length - 1 && (
                <Text style={styles.pathDivider}>/</Text>
              )}
            </PressableOpacity>
          </Animated.View>
        )}
        keyExtractor={item => item.id?.toString() || 'files'}
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={styles.listContentContainer}
      />
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  breadcrumbItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 0,
  },
  breadcrumbItemContainer: {
    backgroundColor:
      theme.mode === 'dark' ? getLightShadeColor(0.1) : getDarkShadeColor(0.05),
    borderRadius: 10,
    padding: 5,
    paddingHorizontal: 10,
  },
  pathDivider: { marginHorizontal: 5 },
  listContentContainer: { paddingRight: 20 },
}))
